$(function(){

	console.log('%c Rich Cronin', 'font-size: 24px; color: #455CE9');
	console.log('%c richcronin.co.uk', 'font-size: 12px; color: #455CE9');

	const body 				= $('body');
	const header 			= $('.site-header');
	const footer 			= $('.site-footer');
	const tablet_breakpoint = 990;
	const mobile_breakpoint = 768;

	function getParameterByName( name ) {
      name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
      var regexS = "[\\?&]"+name+"=([^&#]*)";
      var regex = new RegExp( regexS );
      var results = regex.exec( window.location.href );
      if( results == null )
        return "";
      else
        return decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    function matchHeights(selector) {
	  var maxHeight = 0;

	  $(selector).css('height', 'auto');

	  $(selector).each(function () {
	    var h = $(this).outerHeight();
	    if (h > maxHeight) {
	      maxHeight = h;
	    }
	  });

	  $(selector).height(maxHeight);
	}

	// usage
	$(document).ready(function () {
	  	matchHeights('[data-product-mh]');
	  	matchHeights('[data-mh-pricing]');
	  	if ($(window).width() > tablet_breakpoint) {
	  		matchHeights('[data-benefit-block]');
	  	}
	});

	$(document).on('click', '[data-card-bullet-toggle-on]', function(){
		$(this).closest('.card-product').addClass('overlay-expanded');
	});
	$(document).on('click', '[data-card-bullet-toggle-off]', function(){
		$(this).closest('.card-product').removeClass('overlay-expanded');
	});

	function setCookie(name, value, days) {
	  var expires = '';
	  if (days) {
	    var date = new Date();
	    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	    expires = '; expires=' + date.toUTCString();
	  }
	  document.cookie = name + '=' + value + expires + '; path=/';
	}

	function getCookie(name) {
	  var nameEQ = name + '=';
	  var ca = document.cookie.split(';');
	  for (var i = 0; i < ca.length; i++) {
	    var c = ca[i].trim();
	    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
	  }
	  return null;
	}

	var vat = getCookie('vat_display');

	$(document).on('click', '.site-header .vat-toggle', function(e){

		e.preventDefault();

		var $toggle = $(this).toggleClass('active');

		var vat = $toggle.data('vat'); // current value

		// toggle it
		vat = (vat === 'price-incvat') ? 'price-exvat' : 'price-incvat';

		// persist it on the element + cookie
		$toggle.data('vat', vat);
		setCookie('vat_display', vat, 7);

		console.log('vat now:', vat);

		// update UI
		$('[data-price-incvat]').toggle(vat === 'price-incvat');
		$('[data-price-exvat]').toggle(vat === 'price-exvat');

	});

	if ($(window).width() < tablet_breakpoint) {
		
		$(document).on('click', '.site-navigation--ul [data-mm] .primary-link', function(e){
			e.preventDefault();
			$(this).parent().addClass('mm-expand');
		});

		$(document).on('click', '.site-navigation--ul [data-column-title]', function(e){
			e.preventDefault();
			$(this).parent().addClass('ul-expand');
		});

		$(document).on('click', '[data-menu-drawer-toggle]', function(e){
			e.preventDefault();
			body.toggleClass('menu-expanded');
		});

		$(document).on('click', '[data-menu-close]', function(e){
			e.preventDefault();
			body.removeClass('menu-expanded');
			$('[data-mm]').removeClass('mm-expand');
			$('.column-menus .col.ul-expand').removeClass('ul-expand');
		});

		$(document).on('click', '[data-mm-back]', function(e){
			e.preventDefault();
			$('[data-mm]').removeClass('mm-expand');
		});

		$(document).on('click', '[data-ul-back]', function(e){
			e.preventDefault();
			$('.column-menus .col.ul-expand').removeClass('ul-expand');
		});

		
	}

	if ($('body').data('template') === 'cart') {

		function rerenderCartDrawer() {
		  return $.get('/cart', function (data) {
		    const updatedCart = $(data).find('#cart-rerender').html();
		    $('#cart-rerender').html(updatedCart);

		    // update count (use whatever selector matches your markup)
		    const cartCount = $('#cart-rerender .item').length; // or $('.cart-output .item').length
		    //$('.cart-drawer .head [data-cart-count]').text(cartCount);
		    loadCartRelated();
		  });
		}

	} else {

		function rerenderCartDrawer() {
		  return $.get('/?sections=cart-drawer', function (res) {
		    const sections = typeof res === 'string' ? JSON.parse(res) : res;

		    const drawerHtml = sections['cart-drawer'];
		    const updatedCart = $(drawerHtml).find('#cart-rerender').html();

		    $('#cart-rerender').html(updatedCart);

		    loadCartRelated();
		  });
		}

	}




	$(document).on('click', '[data-add-to-cart]', function (e) {
		
		e.preventDefault();

		  const vid = $(this).data('vid');
		  if (!vid) return;

		  $.ajax({
		    type: 'POST',
		    url: '/cart/add.js',
		    data: { id: vid, quantity: 1 },
		    dataType: 'json',
		    success: function (item) {
		      $('.cart-drawer').fadeIn().addClass('expanded');
		      localStorage.setItem('last_added_product_id', item.product_id);
		      // rerender items + count
		      rerenderCartDrawer();
		    },
		    error: function (err) {
		      console.error('Add to cart failed:', err);
		    }
		  });
		
	});

	$.getJSON('/cart.js', function(cart){
  		if (cart.item_count === 0) localStorage.removeItem('last_added_product_id');
	});


	$(document).on('click', '[data-collapsible-accordion]', function(e){

		e.preventDefault();
		$(this).parent().toggleClass('expanded');

	});

	if ($(window).width() > tablet_breakpoint) {
		$('[data-mm]').on('mouseenter', function () {
			$('.header-mm-bg').addClass('active');
		}).on('mouseleave', function () {
			$('.header-mm-bg').removeClass('active');
		});
	}

	$(document).on('click', '[data-cart-toggle]', function(e){

		e.preventDefault(); 
		$('.cart-drawer').fadeToggle();
		$('.cart-drawer').toggleClass('expanded');

	});

	function changeLineItemQty(lineKey, newQty) {
	  return $.ajax({
	    type: 'POST',
	    url: '/cart/change.js',
	    data: {
	      id: lineKey,       // IMPORTANT: for /cart/change.js, id can be the line item key
	      quantity: newQty
	    },
	    dataType: 'json'
	  });
	}

	$(document).on('click', '[data-qty-plus]', function (e) {
	  e.preventDefault();

	  const $wrap = $(this).closest('.j-qty-selection');
	  const lineKey = $wrap.data('line-key');
	  const $input = $wrap.find('input[name="quantity"]');

	  const currentQty = parseInt($input.val(), 10) || 0;
	  const newQty = currentQty + 1;

	  changeLineItemQty(lineKey, newQty)
	    .done(() => rerenderCartDrawer())
	    .fail(err => console.error('Qty increase failed:', err));
	});

	$(document).on('click', '[data-qty-minus]', function (e) {
	  e.preventDefault();

	  const $wrap = $(this).closest('.j-qty-selection');
	  const lineKey = $wrap.data('line-key');
	  const $input = $wrap.find('input[name="quantity"]');

	  const currentQty = parseInt($input.val(), 10) || 0;
	  const newQty = Math.max(currentQty - 1, 0); // 0 = remove

	  changeLineItemQty(lineKey, newQty)
	    .done(() => rerenderCartDrawer())
	    .fail(err => console.error('Qty decrease failed:', err));
	});

	function loadCartRelated() {
	  const $el = $('#cart-related');
	  if (!$el.length) return;

	  const storedProductId = localStorage.getItem('last_added_product_id');
	  const fallbackProductId = $el.data('fallback-product-id');

	  const productId = storedProductId || fallbackProductId;
	  if (!productId) return;

	  const url =
	    `/recommendations/products` +
	    `?section_id=product-recommendations` +
	    `&product_id=${productId}` +
	    `&limit=3` +
	    `&intent=related`;

	  $.get(url).done(html => $el.html(html));
	}

	loadCartRelated();

	


	$(document).on('click', '.cart-remove-item', function (e) {
		  e.preventDefault();

		  const $btn = $(this);
		  const name = $btn.attr('name');
		  const matches = name.match(/updates\[(\d+):.*?\]/);
		  if (!matches || !matches[1]) return;

		  const lineItemId = matches[1];

		  $.ajax({
		    type: 'POST',
		    url: '/cart/change.js',
		    data: { id: lineItemId, quantity: 0 },
		    dataType: 'json',
		    success: function () {
		      rerenderCartDrawer();
		    },
		    error: function (err) {
		      console.error('Remove failed:', err);
		    }
		});

	});


	  const $form = $('#search-form');
	  const $input = $form.find('input[name="q"]');
	  const $container = $('#search-results-container');

	  const SECTION_ID = 'predictive-search-results';
	  const LIMIT = 8;
	  const DEBOUNCE_MS = 200;

	  let t;
	  let xhr;

		function fetchSuggest(q) {
		  return $.ajax({
		    url: '/search/suggest',
		    method: 'GET',
		    dataType: 'html',
		    data: {
		      q,
		      section_id: SECTION_ID,
		      'resources[type]': 'product',
		      'resources[limit]': LIMIT,
		      'resources[options][unavailable_products]': 'hide'
		    }
		  });
		}

		function fetchSkuFallback(q) {
		  return $.ajax({
		    url: '/search',
		    method: 'GET',
		    dataType: 'html',
		    data: {
		      q: q,
		      type: 'product',
		      view: 'predictive-sku'
		    }
		  });
		}

		function fetchResults(q) {
		  if (xhr) xhr.abort();

		  xhr = fetchSuggest(q).done(function (html) {
		    $container.html(html).show();

		    // if no items, fallback to SKU search
		    const hasResults = $container.find('.predictive-search__item').length > 0;
		    if (!hasResults) {
		      xhr = fetchSkuFallback(q).done(function (html2) {
		        $container.html(html2).show();
		      });
		    }
		  }).fail(function (err) {
		    if (err && err.statusText === 'abort') return;
		    $container.empty().hide();
		  });
		}


	  $input.on('input', function () {
	    clearTimeout(t);

	    const q = ($input.val() || '').trim();
	    if (q.length < 2) {
	      if (xhr) xhr.abort();
	      $container.empty().hide();
	      return;
	    }

	    t = setTimeout(() => fetchResults(q), DEBOUNCE_MS);
	  });

	  // optional: close on outside click
	  $(document).on('click', function (e) {
	    if ($(e.target).closest('#search-form, #search-results-container').length) return;
	    $container.hide();
	  });

	  // keep normal search submit behavior
	  $form.on('submit', function () {
	    $container.hide();
	  });

	  $(document).on('click', '.custom-b2b-pricing--showmore', function(){

	  	$('.custom-b2b-pricing-block').addClass('expanded');

	  });



	  // Comparrison logic


	// Comparrison logic (HTML rendering via /search view)
	// Requires:
	// - templates/search.comparrison-html.liquid (layout none, renders comparrison-item snippet per product)
	// - snippets/comparrison-item.liquid (wrapper markup with .comparrison-item[data-id] + .comparrison-remove[data-remove])
	// - Your product cards include [data-comparrison-check] input[type="checkbox"][data-pid]

	var STORAGE_KEY = "comparrison";
	var CONTEXT_KEY = STORAGE_KEY + ":context";
	var MAX = 4;

	function getComparisonContext() {
	  var body = document.body;

	  if (body && body.hasAttribute('data-cc')) {
	    return body.getAttribute('data-cc');
	  }

	  return window.location.pathname;
	}


	function ensureContextOrClear() {
	  var current = getComparisonContext();
	  var prev = localStorage.getItem(CONTEXT_KEY);

	  if (prev && prev !== current) {
	    localStorage.removeItem(STORAGE_KEY); // clear comparison list
	  }

	  localStorage.setItem(CONTEXT_KEY, current);
	}

	function getList() {
	  try {
	    var v = JSON.parse(localStorage.getItem(STORAGE_KEY));
	    return Array.isArray(v) ? v : [];
	  } catch (e) {
	    return [];
	  }
	}

	function setList(list) {
	  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
	}

	function clearAll() {
	  setList([]);
	}

	function addId(id) {
	  id = String(id);
	  var list = getList().map(String);

	  if (list.indexOf(id) !== -1) return { list: list, blocked: false };
	  if (list.length >= MAX) return { list: list, blocked: true };

	  list.push(id);
	  setList(list);
	  return { list: list, blocked: false };
	}

	function removeId(id) {
	  id = String(id);
	  var next = getList().map(String).filter(function (x) { return x !== id; });
	  setList(next);
	  return next;
	}

	function updateComparisonCount() {
	  var count = getList().length;
	  $('[data-comparrison-count]').text(count);
	}


	function syncCheckboxes() {
	  var list = getList().map(String);

	  $('[data-comparrison-check] input[type="checkbox"][data-pid]').each(function () {
	    var $cb = $(this);
	    $cb.prop("checked", list.indexOf(String($cb.data("pid"))) !== -1);
	  });
	}

	function toggleGridActive() {
	  var hasItems = getList().length > 0;
	  $("#comparrison-grid").toggleClass("active", hasItems);
	}

	function toggleCompareButton() {
	  var count = getList().length;
	  $("#comparrison-grid .comparrison-controls .btn").toggleClass("disabled", count <= 1);
	}

	// --- Fetch HTML rendered by Liquid (search view) ---
	function fetchProductsHtmlByIds(ids) {
	  if (!ids.length) return $.Deferred().resolve("").promise();

	  var q = $.map(ids, function (id) { return "id:" + id; }).join(" OR ");
	  var url = "/search?type=product&q=" + encodeURIComponent(q) + "&view=comparrison-html";

	  return $.get(url); // HTML string
	}

	function hideEmptySpecGroups() {
	  const groups = document.querySelectorAll('[data-product-specs-table--group]');

	  const processed = new Set();

	  groups.forEach(group => {
	    const groupName = group.getAttribute('data-product-specs-table--group');

	    // prevent checking same group multiple times
	    if (processed.has(groupName)) return;
	    processed.add(groupName);

	    const matchingGroups = document.querySelectorAll(
	      `[data-product-specs-table--group="${groupName}"]`
	    );

	    const allEmpty = Array.from(matchingGroups).every(g => {
	      const valueEl = g.querySelector('.group--mf-value');
	      return !valueEl || valueEl.textContent.trim() === '';
	    });

	    if (allEmpty) {
	      matchingGroups.forEach(g => {
	        g.style.display = 'none';
	      });
	    }
	  });
	}


	function renderGrid() {
	  var $grid = $("#comparrison-grid .comparrison-grid");
	  if (!$grid.length) return;

	  var ids = getList().map(String);

	  toggleGridActive();
	  toggleCompareButton();
	   updateComparisonCount();

	  if (!ids.length) {
	    $grid.empty();
	    return;
	  }

	  fetchProductsHtmlByIds(ids).done(function (html) {
	    var $tmp = $("<div/>").html(html);

	    // Expect .comparrison-item[data-id] for each rendered product
	    var byId = {};
	    $tmp.find(".comparrison-item[data-id]").each(function () {
	      byId[String($(this).data("id"))] = this.outerHTML;
	    });

	    // Order according to localStorage ids
	    var orderedHtml = $.map(ids, function (id) { return byId[id]; }).filter(Boolean).join("");

	    // Pad remaining slots with skeletons
	    var skeletonCount = Math.max(0, MAX - ids.length);
	    $grid.html(orderedHtml);

	    // If you use match heights, keep these
	    if (typeof matchHeights === "function") {
	      matchHeights('[data-product-mh-com]');
	      matchHeights('[data-mh-pricing]');
	      // Collect unique group names
			var groups = {};

			$('[data-product-specs-table--group]').each(function () {
			  var group = $(this).attr('data-product-specs-table--group');
			  if (group) groups[group] = true;
			});

			// Run matchHeights per group
			$.each(groups, function (group) {
			  matchHeights('[data-product-specs-table--group="' + group + '"]');
			  console.log(group);
			});
	      matchHeights('[data-product-specs-mh]');
	    } 
	    var vat = getCookie('vat_display');
		if (vat === 'price-exvat') {
			$('.vat-toggle').addClass('active').data('vat', 'price-exvat');
			$('[data-price-incvat]').hide();
			$('[data-price-exvat]').show();
		}

		hideEmptySpecGroups();

	  }).fail(function () {
	    $grid.html("<p>Unable to load comparison products.</p>");
	  });
	}

	// Checkbox change (delegated)
	$(document).on("change", '[data-comparrison-check] input[type="checkbox"][data-pid]', function () {
	  var $cb = $(this);
	  var id = String($cb.data("pid"));

	  if ($cb.is(":checked")) {
	    var result = addId(id);
	    if (result.blocked) {
	      $cb.prop("checked", false);
	      alert("You can compare up to " + MAX + " products.");
	      return;
	    }
	  } else {
	    removeId(id);
	  }

	  syncCheckboxes();
	  renderGrid();
	});

	// Remove button in grid (delegated)
	$(document).on("click", ".comparrison-remove", function () {
	  var id = String($(this).data("remove"));
	  removeId(id);
	  syncCheckboxes();
	  renderGrid();
	});

	// Clear all
	$(document).on("click", "[data-clear-comparrison]", function (e) {
	  e.preventDefault();
	  clearAll();
	  syncCheckboxes();
	  renderGrid();
	  $('#comparrison-grid').removeClass('expanded');
	});

	// Init
	ensureContextOrClear();
	syncCheckboxes();
	renderGrid();
		  

	// Expand comparrison view		  
	$(document).on('click', '[data-expand-comparrison-view]', function(e){

		e.preventDefault();
		$('#comparrison-grid').addClass('expanded');
		syncCheckboxes();
		renderGrid();

	});

	$(document).on('click', '[data-minify-comparrison-view]', function(e){

		e.preventDefault();
		$('#comparrison-grid').removeClass('expanded');
		syncCheckboxes();
		renderGrid();

	});

	if (vat === 'price-exvat') {
		$('.vat-toggle').addClass('active').data('vat', 'price-exvat');
		$('[data-price-incvat]').hide();
		$('[data-price-exvat]').show();
	}

	$(document).on('click', '[data-scroll-to-top]', function (e) {
	  e.preventDefault();

	  $('html, body').animate({
	    scrollTop: 0
	  }, 600);
	});



});